import { render } from "./DetailCompetencesSection.vue?vue&type=template&id=97415f6a&scoped=true"
import script from "./DetailCompetencesSection.vue?vue&type=script&lang=js"
export * from "./DetailCompetencesSection.vue?vue&type=script&lang=js"

import "./DetailCompetencesSection.vue?vue&type=style&index=0&id=97415f6a&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97415f6a"]])

export default __exports__